import { apiClient } from './apiClient';
import type {
  Company,
  CreateCompanyRequest,
  UpdateCompanyRequest,
  PaginatedCompanies,
  PaginationParams,
} from '../../api/types';

export async function listCompanies(params?: PaginationParams): Promise<PaginatedCompanies> {
  const { data } = await apiClient.get<PaginatedCompanies>('/companies', { params });
  return data;
}

export async function getCompanyById(companyId: string): Promise<Company> {
  const { data } = await apiClient.get<Company>(`/companies/${companyId}`);
  return data;
}

export async function createCompany(data: CreateCompanyRequest): Promise<Company> {
  const { data: response } = await apiClient.post<Company>('/companies', data);
  return response;
}

export async function updateCompany(
  companyId: string,
  data: UpdateCompanyRequest,
): Promise<Company> {
  const { data: response } = await apiClient.patch<Company>(`/companies/${companyId}`, data);
  return response;
}

export async function archiveCompany(companyId: string): Promise<Company> {
  const { data: response } = await apiClient.post<Company>(
    `/companies/${companyId}/archive`,
  );
  return response;
}
